import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import * as UI from './../../EmployeeDashboard/Utils/uiGenerators'
import MaterialTable from 'material-table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
import { ShiftSegmentTypeName } from '../../../Enums';
import { PartialIcon } from '../../components/core';
import _ from 'lodash';
import { getAsLongDate, getAsStartAndEndTimeFormat } from '../../../../common-client2/src/services/ukgDateTime';


const useStyles = makeStyles({
  root: {
    marginTop: 10,
  },
  rejectButton:
  {
    "background": "#FFFFFF 0% 0% no-repeat padding-box",
    "border": "1px solid #AFC6DF",
    color: '#F46F6F'
  },
  acceptButton: {
    "&:hover": {
      background: "#3288e3",

    },
    color: "#FFFFFF",
    background: "#0A54A2 0% 0% no-repeat padding-box",
    border: "1px solid #0A54A2",
  },
  detailPanel: {
    backgroundColor: 'rgba(248, 250, 252, 1)',
    alignItems: 'center',
    padding: 5,
  },
  button:
  {
    marginLeft: "1vw",
    marginBottom: "1vw",
    textAlign: "center",
    font: "Medium 16px/18px Roboto",
    letterSpacing: "0",
    opacity: "1",
    width: '6.9vw',
    borderRadius: "2px",
  },
  sideColor: {
    borderLeft: '4px solid #0A54A2'
  },
  date: {
    fontSize: 16,
  },
  time: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  pos: {
    marginBottom: 12,
  },
  bold: {
    fontWeight: 'bold',
  },
  space: {
    marginBottom: 5,
  }
});

export default function ProposalCard(props) {
  const classes = useStyles();
  const hasActions = props.hasActions;
  let acceptedStatusId = [1, 2, 7];
  let acceptedProposal = props.proposals.find(x => acceptedStatusId.includes(x.status));
  let listToShow;

  if (acceptedProposal) {
    listToShow = [acceptedProposal];
  } else {
    listToShow = props.proposals;
  }
  return (
    <React.Fragment>
      {
        listToShow.map(ele =>
          <Card className={[classes.root, classes.sideColor]}>
            <CardContent >
              <Typography className={classes.time} variant="h6" component="h2">
                {ele.name}
              </Typography>
              <Typography className={[classes.date, classes.space]} color="textSecondary">
                Proposed On: {ele.date} at {ele.time}
              </Typography>
              <MaterialTable
                columns={[
                  {
                    title: 'Date',
                    field: 'shift.label',
                    render: rowData => {
                      return (
                        <React.Fragment>
                          {getAsLongDate(ele.isPartial ? ele.partialShift.startDateTime : rowData.startDateTime)}
                        </React.Fragment>
                      )
                    },
                  },
                  {
                    title: 'Shift',
                    field: 'shift.label',
                    render: rowData => {
                      const isPartialShift = ele.isPartial;
                      const startDate = isPartialShift ? ele.partialShift.startDateTime : rowData.startDateTime;
                      const endDate = isPartialShift ? ele.partialShift.endDateTime : rowData.endDateTime;
                      const transferExists = rowData.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT) ? '(x)' : '';
                      const shiftLabel = `${rowData.label ?? ""} ${getAsStartAndEndTimeFormat(startDate, endDate)} ${transferExists}`;
                      if (isPartialShift) {
                        return (
                          <React.Fragment>
                            <PartialIcon />
                            <span style={{ padding: '0 5px' }}>
                              {shiftLabel}
                            </span>
                          </React.Fragment>
                        )
                      }
                      return (
                        <React.Fragment>
                          {shiftLabel}
                        </React.Fragment>
                      )
                    },
                  },
                ]}
                data={_.sortBy(ele.shifts, ['startDateTime'])}
                detailPanel={[
                  {
                    icon: rowData => { return <FontAwesomeIcon icon={faAngleDown} className={classes.plusMinus} /> },
                    iconProps: { classes },
                    openIcon: rowData => { return <FontAwesomeIcon icon={faAngleUp} className={classes.plusMinus} /> },
                    openIconProps: { classes },
                    render: rowData => {
                      const shift = ele.isPartial ? ele.partialShift : rowData;
                      return (
                        <div className={classes.detailPanel}>
                          <Typography component="h2" style={{
                            fontWeight: 700,
                          }}>
                            Segments
                          </Typography>
                          {UI.buildDailyShiftSegments(shift)}
                        </div>
                      )
                    }
                  }
                ]}
                options={{
                  search: false,
                  sorting: false,
                  showTitle: false,
                  draggable: false,
                  toolbar: false,
                  showSelectAllCheckbox: false,
                  showTextRowsSelected: false,
                  paging: false,
                  grouping: false,
                }}
                style={{ 'width': '100%' }}
              />
            </CardContent>
            {
              hasActions &&
              <CardActions>
                <Button onClick={() => props.handleAcceptButton(ele.proposalId)} className={[classes.button, classes.acceptButton]} size="medium">Accept</Button>
                <Button onClick={() => props.handleRejectButton(ele.proposalId)} className={[classes.button, classes.rejectButton]} size="medium">Decline</Button>
              </CardActions>
            }
          </Card>
        )
      }
    </React.Fragment>
  );
}